var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHand = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.406 8.26c-.606-.345-1.363-.09-1.691.534l-1.617 3.297a.274.274 0 0 1-.521-.12v-9.16c0-.543-.502-.937-1.046-.937-.543 0-1.015.394-1.015.938V8.93a.44.44 0 0 1-.422.444.43.43 0 0 1-.438-.43V.937c0-.543-.427-.937-.97-.937-.545 0-.983.394-.983.938V8.93a.44.44 0 0 1-.421.444.43.43 0 0 1-.438-.43V2.187c0-.543-.472-.937-1.016-.937s-1.015.433-1.015.977v7.33A.44.44 0 0 1 5.39 10a.43.43 0 0 1-.438-.43V4.687c0-.543-.433-.937-.976-.937-.544 0-.982.4-.977.938v8.437C3 17.711 5.813 20 9.25 20h.625c3.438 0 4.52-1.547 5.313-3.438l2.684-6.601c.258-.703.14-1.357-.466-1.702Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHand);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hand.9746cb9ab8e20f0133893cefebae8daa.svg";